
import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LoadingScreen from '@/components/ui/loading-screen';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, refreshSession } = useAuth();

  // Attempt to refresh the session when component mounts and when loading changes
  useEffect(() => {
    const attemptRefresh = async () => {
      if (loading) {
        console.log("[ProtectedRoute] Loading state detected, attempting refresh");
        try {
          await refreshSession();
        } catch (err) {
          console.error("[ProtectedRoute] Refresh error:", err);
        }
      }
    };

    attemptRefresh();
  }, [loading, refreshSession]);

  
  // Show loading screen while authentication state is being determined
  if (loading) {
    return <LoadingScreen />;
  }
  
  // If no user is authenticated after loading, redirect to auth page
  if (!user) {
    console.log("[ProtectedRoute] No authenticated user, redirecting to /auth");
    return <Navigate to="/auth" replace />;
  }
  
  // User is authenticated, render the protected content
  return <>{children}</>;
}
